import React, { useEffect, useState } from "react";
import axios from "axios";
import API_BASE_URL from "../../config";
import {
  BsBuildingFill,
  BsDeviceSsd,
  BsExclamationTriangleFill,
  BsWifi,
} from "react-icons/bs";

export default function OpsOverview() {
  const token = localStorage.getItem("userToken");
  const headers = token ? { Authorization: `Bearer ${token}` } : {};
  const [overview, setOverview] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchOverview = async () => {
      try {
        setLoading(true);
        const overviewRes = await axios.get(`${API_BASE_URL}/ops/overview`, { headers });
        setOverview(overviewRes.data);
        setError("");
      } catch (err) {
        console.error("OpsOverview error", err.response?.data || err.message);
        setError("Unable to load operator overview.");
      } finally {
        setLoading(false);
      }
    };

    fetchOverview();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (loading) {
    return (
      <div className="ops-loading">
        <div className="ops-spinner" />
        <p>Loading overview...</p>
      </div>
    );
  }

  if (error) {
    return <div className="ops-error"><BsExclamationTriangleFill /> {error}</div>;
  }

  return (
    <div>
      {/* Summary Cards */}
      <div className="ops-overview-grid">
        <div className="ops-overview-card">
          <div className="ops-overview-icon ops-icon-blue">
            <BsBuildingFill />
          </div>
          <div className="ops-overview-info">
            <span className="ops-overview-label">Companies</span>
            <strong className="ops-overview-value">{overview?.companies ?? 0}</strong>
          </div>
        </div>
        <div className="ops-overview-card">
          <div className="ops-overview-icon ops-icon-green">
            <BsWifi />
          </div>
          <div className="ops-overview-info">
            <span className="ops-overview-label">Active Devices</span>
            <strong className="ops-overview-value">{overview?.activeDevices ?? 0}</strong>
          </div>
        </div>
        <div className="ops-overview-card">
          <div className="ops-overview-icon ops-icon-purple">
            <BsDeviceSsd />
          </div>
          <div className="ops-overview-info">
            <span className="ops-overview-label">Total Devices</span>
            <strong className="ops-overview-value">{overview?.totalDevices ?? 0}</strong>
          </div>
        </div>
      </div>
    </div>
  );
}
